import { SessionModel } from '@/models/auth/session';
import { authSerializer } from '@/providers/serializers/auth/auth';

export class SessionService {

  private static INSTANCE = new SessionService();

  static get instance() {
    return this.INSTANCE;
  }

  public DEMO_SESSION: string = 'LI_DEMO_SESSION';

  public SESSION: string = 'LI_SESSION';

  public LI_UPDATE: string = 'LI_UPDATE_LOGIN';

  private SESSION_RGO: string = 'ember_simple_auth-session';

  private FACET_REQUEST_PAYLOAD: string = 'LI_REQUEST_PAYLOAD';


  public getSession() {
    let session = null;
    const sessionAsString: string | null = localStorage.getItem(this.SESSION);
    if (sessionAsString) {
      const sessionAsJson = JSON.parse(sessionAsString);
      session = authSerializer.sessionModelSerializer(sessionAsJson);
    }
    return session;
  }

  public setSession(session: SessionModel) {
    localStorage.setItem(this.SESSION, JSON.stringify(session));
    localStorage.setItem(this.SESSION_RGO, JSON.stringify(authSerializer.sessionModelRGOSerializer(session)));
  }

  public deleteSession() {
    localStorage.removeItem(this.FACET_REQUEST_PAYLOAD);
    localStorage.removeItem(this.SESSION);
    localStorage.removeItem(this.SESSION_RGO);
    localStorage.removeItem('isFacet');
    localStorage.removeItem('facetQueryParams');
  }
  public setDemoSessionCopy() {
    const session: any = JSON.stringify(this.getSession());
    localStorage.setItem(this.DEMO_SESSION, session);
  }

  public getDemoSessionCopy() {
    const demoSession: any = localStorage.getItem(this.DEMO_SESSION);
    const session: any = JSON.parse(demoSession);
    return session;
  }

  public getMcUpdate() {
    const login: any = localStorage.getItem(this.LI_UPDATE);
    return JSON.parse(login);
  }

  public deleteMcUpdate() {
    localStorage.removeItem(this.LI_UPDATE);
  }

  public isAuthorized() {
    const session = this.getSession();
    return (session && session.access_token);
  }

  public getCdnUrl() {
    const service = this;
    const session = service.getSession();
    return session ? session.cdn_urls : null;
  }

  public getTenantLogo() {
    const session = this.getSession();
    const tenantSettings = session!.tenant!.settings;
    const logo = tenantSettings && tenantSettings.ui_element_visibility_settings &&
    tenantSettings.ui_element_visibility_settings.logo_url && tenantSettings.ui_element_visibility_settings.show_logo ?
    tenantSettings.ui_element_visibility_settings.logo_url : null;
    return logo;
  }
}

export const sessionService = SessionService.instance;
